const _ = require("lodash");
const { city } = require("../../env.js");

module.exports.站點 = {
  "血壓/脈搏": "pressure-1",
  第二次血壓: "pressure-2",
  體檢: "body",
  握力: "strength",
  視力: "vision",
  口腔檢查: "cavity",
  // 子抹檢查: "cervix",
  回收檢查: "final",
};
module.exports.站點項目 = [
  "第一次收縮壓",
  "第一次舒張壓",
  "第二次收縮壓",
  "第二次舒張壓",
  "脈搏",
  "身高",
  "體重",
  "腰圍",
  "體脂肪",
  "左手握力",
  "右手握力",
  "視力",
  "左眼",
  "右眼",
  "口腔白斑",
  "口腔齲齒",
  "口腔牙周病",
  "口腔無牙",
];
module.exports.健檢項目 = {
  成健: {
    logo: "/images/成人預防保健logo.png",
    title: "成人預防保健",
    content:
      "30-39歲民眾5年1次<br>40-64歲民眾3年1次<br>55歲以上原住民或65歲以上一般民眾每年1次，需空腹 8 小時",
    notice:
      "已領取三高慢性處方箋，並配合定期檢查及常規治療，其檢查項目已有血壓、血糖、血膽固醇及三酸甘油脂四項成人預防保健服務相同之檢查項目者，以及已為品質改善試辦(P4P)計畫內之糖尿病(DM)、初期腎病(CKD)及糖腎共照 (DKD)計畫等收案管理之對象，不提供本項服務。",
  },
  BC肝: {
    logo: "/images/BC肝logo.png",
    title: "B、C肝檢查",
    content: "39-79歲民眾終身一次<br>(75年次以前出生)",
  },
  子抹: {
    logo: "/images/子宮抹片檢查logo.png",
    title: "子宮抹片檢查",
    content: "25-29歲有性行為之女性每3年1次<br>30歲以上有性行為之女性每年1次",
  },
  大腸: {
    logo: "/images/糞便潛血檢查logo.png",
    title: "糞便潛血檢查",
    content:
      "40-44歲有大腸癌家族史(父母、兄弟姐妹、子女曾患有大腸癌者)或45-未滿75歲每2年檢查1次",
  },
  口腔: {
    logo: "/images/口腔黏膜檢查logo.png",
    title: "口腔黏膜檢查",
    content:
      "30歲以上有嚼檳榔(含已戒)或吸菸者<br>18歲以上有嚼檳榔(含已戒)原住民<br>每2年一次",
  },
  乳攝: {
    logo: "/images/乳房X光logo.png",
    title: "乳房X光攝影",
    content: "40-未滿75歲女性每2年1次",
  },
  LDCT: {
    logo: "/images/LDCTlogo.png",
    title: "肺部電腦斷層",
    content:
      "45歲-74歲男性有肺癌家族史<br>40歲-74歲女性有肺癌家族史<br>50歲-74歲有重度吸菸者<br>每2年1次",
  },
  HPV: {
    logo: "/images/HPVlogo.png",
    title: "人類乳突病毒檢查",
    content: "35歲、45歲及65歲女性",
  },
  胃篩: {
    logo: "/images/胃篩logo.png",
    title: "胃幽門螺旋桿菌",
    content: "45-未滿75歲終身1次",
  },
  ICOPE: {
    logo: "/images/ICOPElogo.png",
    title: "長者能力檢測",
    content: "65歲以上長者<br>55歲以上原住民每年1次",
  },
};
module.exports.教育程度 = [
  "無",
  "小學",
  "國(初)中",
  "高中/高職",
  "專科、大學",
  "研究所以上",
  "拒答",
];
module.exports.女性三等親 = [
  "祖母",
  "外祖母",
  "母親",
  "女兒",
  "姊姊",
  "妹妹",
  "姑姑",
  "阿姨",
];
module.exports.家族疾病史 = [
  "高血壓",
  "糖尿病",
  "高血脂症",
  "心臟病",
  "腦中風",
  "癲癇",
  "B/C型肝炎帶原",
  "慢性肝炎/肝硬化",
  "精神疾病",
  "痛風",
  "巴金森氏症",
  "結核病",
  "氣喘",
  "尿路結石",
  "腎臟病",
  "家族性大腸瘜肉症",
  "大腸直腸瘜肉",
  "血癌（白血病）",
  "骨癌",
  "鼻咽癌",
  "口腔癌",
  "食道癌",
  "子宮頸癌",
  "乳癌",
  "肝癌",
  "肺癌",
  "胃癌",
  "胰臟癌",
  "膽囊癌",
  "卵巢癌",
  "攝護腺癌",
  "遺傳性非瘜肉大腸直腸癌",
  "其他癌症",
  "其他慢性疾病",
];
module.exports.個人疾病史 = [
  "高血壓",
  "糖尿病",
  "高血脂症",
  "心臟病",
  "腦中風",
  "B型肝炎",
  "C型肝炎",
  "神經疾病",
  "痛風",
  "骨質疏鬆",
  "結核病",
  "氣喘",
  "慢性潰瘍結腸炎",
  "尿路結石",
  "家族性大腸瘜肉症",
  "大腸直腸瘜肉",
  "骨刺",
  "乳癌",
  "攝護腺癌",
  "腎臟病",
  "其他精神疾病",
  "其他癌症",
  "其他疾病",
];

const 行政區s = {
  臺南市: [
    "中西區",
    "東區",
    "南區",
    "北區",
    "安平區",
    "安南區",
    "永康區",
    "歸仁區",
    "新化區",
    "左鎮區",
    "玉井區",
    "楠西區",
    "南化區",
    "仁德區",
    "關廟區",
    "龍崎區",
    "官田區",
    "麻豆區",
    "佳里區",
    "西港區",
    "七股區",
    "將軍區",
    "學甲區",
    "北門區",
    "新營區",
    "後壁區",
    "白河區",
    "東山區",
    "六甲區",
    "下營區",
    "柳營區",
    "鹽水區",
    "善化區",
    "大內區",
    "山上區",
    "新市區",
    "安定區",
  ],
  高雄市: [
    "鹽埕區",
    "鼓山區",
    "左營區",
    "楠梓區",
    "三民區1",
    "三民區2",
    "新興區",
    "前金區",
    "苓雅區",
    "前鎮區",
    "旗津區",
    "小港區",
    "鳳山區1",
    "鳳山區2",
    "林園區",
    "大寮區",
    "大樹區",
    "大社區",
    "仁武區",
    "鳥松區",
    "岡山區",
    "橋頭區",
    "燕巢區",
    "田寮區",
    "阿蓮區",
    "路竹區",
    "湖內區",
    "茄萣區",
    "永安區",
    "彌陀區",
    "梓官區",
    "旗山區",
    "美濃區",
    "六龜區",
    "甲仙區",
    "杉林區",
    "內門區",
    "茂林區",
    "桃源區",
    "那瑪夏區",
  ],
};

module.exports.行政區 = 行政區s[city.name];
module.exports.行政區F = (行政區s[city.name] || []).map((x) =>
  x.replace(/[0-9]/g, ""),
);
